import {LOGOUT_URL} from "../_actions/auth/authService";

// const HOME_ADDRESS = "http://localhost:8080/api"
// const HOME_ADDRESS = "http://192.168.43.85:8080/api"
export const HOME_ADDRESS = 'http://qi-center.by/api'

export const ADDRESS = HOME_ADDRESS;

export async function client(endpoint, {body, ...customConfig} = {}) {
    const url = ADDRESS + endpoint
    const token = localStorage.getItem("accessToken")

    let headers = body && body instanceof FormData ? {} : {'Content-Type': 'application/json'}
    if (token && token !== "null") {
        headers['Authorization'] = `Bearer ${token}`;
    }

    headers['Referrer'] = document.referrer;

    const config = {
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers,
        },
    }

    if (body) {
        config.body = body instanceof FormData ? body : JSON.stringify(body);
    }

    let data
    let response;
    try {
        response = await window.fetch(url, config)

        // Если не logout
        if (url.indexOf(LOGOUT_URL) === -1) {
            if (body && body instanceof FormData) {
                data = await response.text()
            } else {
                data = await response.json()
            }
        }

        if (response.ok) {
            return {
                status: response.status,
                data,
                headers: response.headers,
                url: url,
            }
        }
        throw new Error(response.statusText)
    } catch (err) {
        if (err.message) {
            return Promise.reject(err.message);
        }
        if (body && body instanceof FormData) {
            return Promise.reject(JSON.parse(data));
        }

        return Promise.reject(JSON.stringify(data))
    }
}

client.get = function (endpoint, customConfig = {}) {
    return client(endpoint, {...customConfig, method: 'GET'})
}

client.post = function (endpoint, body, customConfig = {}) {
    return client(endpoint, {...customConfig, method: 'POST', body})
}

client.put = function (endpoint, body, customConfig = {}) {
    return client(endpoint, {...customConfig, method: 'PUT', body})
}

client.delete = function (endpoint, customConfig = {}) {
    return client(endpoint, {...customConfig, method: 'DELETE'})
}
